'use strict';

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

require('./AutoParser.js');

require('./HttpInterface.js');

var XhrHttpIO = require('./XhrHttpIO.js');

var ActiveRequester =
/*#__PURE__*/
function (_XhrHttpIO$XhrHttpIO) {
  _inheritsLoose(ActiveRequester, _XhrHttpIO$XhrHttpIO);

  function ActiveRequester(options) {
    var _this;

    _this = _XhrHttpIO$XhrHttpIO.call(this, {
      sessionStoreCookieFactory: options.sessionStoreCookieFactory,
      apiPrefix: options.apiPrefix
    }) || this;
    var httpParams = options.httpParams,
        type = options.type;
    _this.attempts = 0;
    _this.maxAttempts = 1;
    _this.firstThrottle = 1000;
    _this.throttle = 3000;
    _this.waitCodes = [202];
    _this.responseType = type || 'application/json';

    if (typeof httpParams === 'object') {
      var fnShouldAbort = httpParams.fnShouldAbort;

      if (typeof fnShouldAbort === 'function') {
        _this.shouldAbort = fnShouldAbort;
      }
    }

    return _this;
  }

  var _proto = ActiveRequester.prototype;

  _proto.get = function get(path, params) {
    this.path = path;
    this.params = params || {};
    return this.timedAjaxCall();
  };

  _proto.timedAjaxCall = function timedAjaxCall() {
    if (this.attempts > this.maxAttempts) {
      return Promise.reject("Number of attempts exceeded: " + this.attempts);
    }

    this.attempts += 1;
    return this.delay().then(this.ajaxCall.bind(this)).then(this.ajaxHandler.bind(this));
  };

  _proto.delay = function delay() {
    var _this2 = this;

    return new Promise(function (resolve) {
      var msToThrottle = _this2.attempts === 1 ? 0 : _this2.attempts === 2 ? _this2.firstThrottle : _this2.throttle;
      setTimeout(resolve, msToThrottle);
    });
  };

  _proto.ajaxCall = function ajaxCall() {
    return _XhrHttpIO$XhrHttpIO.prototype.get.call(this, this.path, this.requestParams, this.responseType);
  };

  _proto.ajaxHandler = function ajaxHandler(res) {
    if (this.shouldAbort()) {
      return Promise.reject('Aborted');
    }

    if (this.isWaitCode(res.status)) {
      return this.timedAjaxCall();
    }

    return res;
  };

  _proto.isWaitCode = function isWaitCode(code) {
    return this.waitCodes.includes(code);
  };

  _proto.shouldAbort = function shouldAbort() {
    return false;
  };

  _createClass(ActiveRequester, [{
    key: "activeRequestConfig",
    set: function set(options) {
      this.firstThrottle = options.start || this.firstThrottle;
      this.throttle = options.interval || this.throttle;
      this.maxAttempts = options.maxAttempts || this.maxAttempts;
      this.waitCodes = options.waitCodes || this.waitCodes;
    }
  }, {
    key: "timestamp",
    get: function get() {
      return new Date().getTime();
    }
  }, {
    key: "requestParams",
    get: function get() {
      var params = Object.assign({}, this.params);

      if (!params.c) {
        params.c = this.timestamp;
      }

      return params;
    }
  }]);

  return ActiveRequester;
}(XhrHttpIO.XhrHttpIO);

exports.ActiveRequester = ActiveRequester;